import { memo } from "react";

interface Props {
  className?: string;
  color?: string;
}
function CricleColorfulIcon({ className, color }: Props) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle
        cx="13"
        cy="13"
        r="12"
        fill="white"
        fillOpacity={color || "0.303649"}
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
}

export default memo(CricleColorfulIcon);
